import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover"
import MoreProject_PopoverColorIcon from "../../../../../../gd-ui/more/project/popover-color-icon"

export default function FieldProjectColorIcon_Popover(props:any) {

    const menuParams = {
        project     : props.model,
        hidePopover : props.parent.hidePopover
    }

    return (
        <Popover attachment         = "top center"
                 targetAttachment   = "bottom center"
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>
            <MoreProject_PopoverColorIcon menuParams = {menuParams}/>
        </Popover>
    )
}